export default "__VITE_ASSET__C9Jjg0fh__"